import { render, staticRenderFns } from "./PlayerBoostFilters.vue?vue&type=template&id=3c20790b&scoped=true"
import script from "./PlayerBoostFilters.vue?vue&type=script&lang=js"
export * from "./PlayerBoostFilters.vue?vue&type=script&lang=js"
import style0 from "./PlayerBoostFilters.vue?vue&type=style&index=0&id=3c20790b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20790b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VIcon,VRow})
